import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import { Navigate } from "react-router-dom";
import { API_URL } from '../config/API_URLS.tsx';
import { authenticatedFetch } from "../auth/RequestSigner.tsx";
import SuccessModal from "./SuccessModal.tsx";
import ErrorModal from "./ErrorModal.tsx";

function SetPassword() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const documentSender = queryParams.get('document') || '';
    const [password, setPassword] = useState("");
    const rollSender = queryParams.get('roll') || '';
    const [homeRedirect, setHomeRedirect] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordsMatch, setPasswordsMatch] = useState(true);
    const [loading, setLoading] = useState(false);
    
    // Estados para los modales
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (password !== confirmPassword) {
            setPasswordsMatch(false);
            return;
        }
        
        setLoading(true);

        try {
            const response = await authenticatedFetch(`${API_URL}/v1/create_user`, {
                method: 'post',
                body: JSON.stringify({ "document": documentSender, password, "roll_id": rollSender }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.status === 400) {
                setErrorMessage('El usuario ya existe');
                setShowErrorModal(true);
                setLoading(false);
                return;
            }
            
            if (response.status === 422) {
                setErrorMessage('Introduce el formato de datos correcto');
                setShowErrorModal(true);
                setLoading(false);
                return;
            }
            
            if (!response.ok) {
                throw new Error('Error en la solicitud');
            }
            
            // const data = await response.json();
            setShowSuccessModal(true);
            
            // Redirección después de 2 segundos
            setTimeout(() => {
                setHomeRedirect(true);
            }, 2000);
            
        } catch (error) {
            console.error('Error:', error);
            setErrorMessage('Error en la solicitud: ' + error.message);
            setShowErrorModal(true);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseErrorModal = () => {
        setShowErrorModal(false);
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        setHomeRedirect(true);
    };

    if (homeRedirect) {
        return <Navigate to="/home" />;
    }

    return (
        <div className="min-h-screen flex items-center justify-center" data-testid="set-password-container">
            <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full border border-gray-200" data-testid="set-password-wrapper">
                <div className="mb-8 text-center">
                    <h2 className="text-2xl font-bold text-gray-800 mb-2" data-testid="set-password-title">Establecer Contraseña</h2>
                    <p className="text-gray-600">Crea una contraseña segura para tu cuenta</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6" data-testid="set-password-form">
                    <div data-testid="set-password-document-field">
                        <label htmlFor="document" className="block text-gray-700 font-medium mb-2" data-testid="set-password-document-label">Documento</label>
                        <input
                            type="text"
                            id="document"
                            name="document"
                            value={documentSender}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent bg-gray-100"
                            disabled
                            data-testid="set-password-document-input"
                        />
                    </div>

                    <div data-testid="set-password-field">
                        <label htmlFor="password" className="block text-gray-700 font-medium mb-2" data-testid="set-password-label">Contraseña</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setPasswordsMatch(e.target.value === confirmPassword || confirmPassword === "");
                            }}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                            required
                            placeholder="Ingresa tu contraseña"
                            data-testid="set-password-input"
                        />
                    </div>

                    <div data-testid="set-password-confirm-field">
                        <label htmlFor="confirmPassword" className="block text-gray-700 font-medium mb-2" data-testid="set-password-confirm-label">Confirmar Contraseña</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => {
                                setConfirmPassword(e.target.value);
                                setPasswordsMatch(password === e.target.value || e.target.value === "");
                            }}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                            required
                            placeholder="Confirma tu contraseña"
                            data-testid="set-password-confirm-input"
                        />
                    </div>

                    {passwordsMatch === false && (
                        <div className="p-3 bg-red-50 text-red-700 rounded-lg border border-red-200" data-testid="set-password-error">
                            <div className="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                </svg>
                                <span>Las contraseñas no coinciden</span>
                            </div>
                        </div>
                    )}

                    <button
                        type="submit"
                        className={`w-full px-4 py-3 rounded-lg shadow-md flex items-center justify-center relative overflow-hidden group
                            ${(!passwordsMatch || !password || !confirmPassword || loading) ? 'bg-gray-300 cursor-not-allowed text-gray-500' : ''}`}
                        disabled={!passwordsMatch || !password || !confirmPassword || loading}
                        data-testid="set-password-submit-button"
                    >
                        {(!passwordsMatch || !password || !confirmPassword || loading) ? (
                            <span>
                                {loading ? (
                                    <div className="flex items-center">
                                        <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-2"></div>
                                        <span>Procesando...</span>
                                    </div>
                                ) : (
                                    "Establecer Contraseña"
                                )}
                            </span>
                        ) : (
                            <>
                                <div className="absolute inset-0 bg-gradient-to-t from-amber-300 to-amber-700 transition-transform duration-700 ease-in-out"></div>
                                <div className="absolute inset-0 bg-gradient-to-b from-amber-300 to-amber-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
                                <span className="relative z-10 text-gray-900">Establecer Contraseña</span>
                            </>
                        )}
                    </button>
                </form>
            </div>
            
            <SuccessModal
                isOpen={showSuccessModal}
                onClose={handleCloseSuccessModal}
                message="Contraseña establecida con éxito. Serás redirigido al inicio."
            />
            
            <ErrorModal
                isOpen={showErrorModal}
                onClose={handleCloseErrorModal}
                message={errorMessage}
            />
        </div>
    );
}

export { SetPassword };
